import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const otpValidationSchema = yup.object().shape({
  otp: yup
    .string()
    .matches(/^[0-9]{6}$/, "OTP must be 6 digits")
    .required("OTP is required"),
});

const OtpValidationForm = ({
  onSubmit,
  switchToForgotPassword,
  onResendOtp,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(otpValidationSchema),
  });

  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      setCanResend(false);
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    } else {
      setCanResend(true);
    }

    return () => clearInterval(interval);
  }, [timer]);

  const handleResend = () => {
    if (canResend) {
      onResendOtp?.();
      setTimer(60);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="auth-form">
      <div className="form-field">
        <input type="text" placeholder="Enter OTP" {...register("otp")} />
        {errors.otp && <p className="error">{errors.otp.message}</p>}
      </div>

      <div className="timer-resend">
        {canResend ? (
          <button type="button" onClick={handleResend} className="resend-link">
            Resend OTP
          </button>
        ) : (
          <p className="timer-text">Resend OTP in {timer}s</p>
        )}
      </div>

      <button type="submit" className="submit-button">
        Submit OTP
      </button>

      <div className="auth-footer">
        <a onClick={switchToForgotPassword} className="login-link">
          Back to Forgot Password
        </a>
      </div>
    </form>
  );
};

export default OtpValidationForm;
